/*!

=========================================================
* Light Bootstrap Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import ChartistGraph from "react-chartist";
import { Grid, Row, Col, Table, FormGroup } from "react-bootstrap";
import Datetime from "react-datetime";
import ProgressButton from "components/ProgressButton/ProgressButton.jsx";
import { WEB_URL } from "variables/Variables.jsx";
import moment from "moment";
import Button from "components/CustomButton/CustomButton.jsx";
import { Card } from "components/Card/Card.jsx";
import { StatsCard } from "components/StatsCard/StatsCard.jsx";
import {
  dataPie,
  legendPie,
  dataSales,
  dataAnalytics,
  optionsSales,
  responsiveSales,
  legendSales,
  legendAnalytics,
  dataBar,
  optionsBar,
  responsiveBar,
  legendBar
} from "variables/Variables.jsx";

class Analytics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dateStart: moment().subtract(1, 'months'),
      dateEnd: moment(),
      avgReadTime : 0,
      uniqueReads : 0,
      linkClicks : 0,
      totalPagesRead : 0,
      pageData : [],
      lineData : {
        labels : [],
        series : []
      },
      lineOptions : {
        low: 0,
        high: 800,
        showArea: false,
        height: "245px",
        axisX: {
          showGrid: false
        },
        lineSmooth: true,
        showLine: true,
        showPoint: true,
        fullWidth: true,
        chartPadding: {
          right: 50
        },
        analyticsDisabled : false
      },
      engagementDetail : null
    }
  }

  componentDidMount () {
    this.fetchStats();
  }

  formatTime(seconds){
    var minutes = Math.floor(seconds / 60);
    var remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${Math.round(remainingSeconds).toString().padStart(2, '0')}`;
  }

  fetchStats(action){
    var _this = this;  
    this.setState({runningSearch : true});

    try{
      fetch("https://"+WEB_URL+"/account/api/getanalytics",{
        'method' : 'POST',
        'headers' : { 'Content-Type' : 'application/json'},
        'body' : JSON.stringify({'token':this.props.authDetail.token, 'identifier' : this.props.match.params.publication, 'dateRangeStart' : this.state.dateStart.toISOString(), 'dateRangeEnd' : this.state.dateEnd.toISOString(),'action' : action, 'trackId' : this.props.match.params.identifier}),
      }).then(res => res.json())
        .then(
          (response) => {
            if(response.result == 'SUCCESS'){
              var da = { labels : [], series : []};
              var dt = [];
              var lowValue = 0;
              var maxValue = 0;
              var totalReads = 0;

              var arhits = [];
              if(response.Events && response.Events.length){

                var lineOpts = {
                  low: 0,
                  high: 800,
                  showArea: false,
                  height: "245px",
                  axisX: {
                    showGrid: false
                  },
                  lineSmooth: true,
                  showLine: true,
                  showPoint: true,
                  fullWidth: true,
                  chartPadding: {
                    right: 50
                  }
                }

                var currentDate = null;
                var currentHits = 0;
                for(var li=0;li<response.Events.length;li++){
                  if(currentDate != response.Events[li].date){
                    da.labels.push(new Date(response.Events[li].date).toLocaleDateString());

                    if(currentDate){
                      arhits.push(currentHits);
                    }

                    currentHits=response.Events[li].hits;
                  }else{
                    currentHits+=response.Events[li].hits;
                  }

                  if(li == response.Events.length -1){
                    arhits.push(currentHits);
                  }

                  totalReads+=response.Events[li].hits;

                  if(currentHits > maxValue){
                    maxValue = currentHits;
                  }
  
                  if(currentHits < lowValue){
                    lowValue = currentHits;
                  }

                  currentDate = response.Events[li].date;

                  if(!dt[response.Events[li].pageNumber]){
                      dt[response.Events[li].pageNumber] = { pageNumber : response.Events[li].pageNumber, hits : response.Events[li].hits, avgTimeSpent : -1, count : 1, clicks : 0, engagementItems : [] };  
                  }else{
                      dt[response.Events[li].pageNumber].count++;
                      dt[response.Events[li].pageNumber].avgTimeSpent = -1
                      dt[response.Events[li].pageNumber].hits += response.Events[li].hits;
                  }
                }
                
                da.series.push(arhits);

                lineOpts.low = lowValue;
                lineOpts.high = maxValue;
                
                this.setState({pageData : dt, lineData : da, lineOptions : lineOpts, totalPagesRead : totalReads, engagementDetail : null});
              }

              if(response.Unique && response.Unique.length){
                var uniqueReads = 0;
                for(var li=0;li<response.Unique.length;li++){
                  uniqueReads+=response.Unique[li].unique;
                }
                this.setState({uniqueReads : uniqueReads});
              }

              if(response.TimeSpent && response.TimeSpent.length){
                var totalTimeSpent = 0;
                for(var tsi=0;tsi<response.TimeSpent.length;tsi++){
                  totalTimeSpent+=response.TimeSpent[tsi].avg;

                  if(dt[response.TimeSpent[tsi].pageNumber]){
                    dt[response.TimeSpent[tsi].pageNumber].avgTimeSpent = response.TimeSpent[tsi].avg;
                  }else{
                    dt[response.TimeSpent[tsi].pageNumber] = { pageNumber : response.TimeSpent[tsi].pageNumber, hits : 0, avgTimeSpent : response.TimeSpent[tsi].avg, count : 0, clicks : 0, engagementItems : [] };
                  }
                }
                this.setState({avgReadTime : Math.round((totalTimeSpent/response.TimeSpent.length)*100)/100});
              }

              if(response.ExtLinks && response.ExtLinks.length){
                var totalLinkClicks = 0;
                for(var li=0;li<response.ExtLinks.length;li++){

                  totalLinkClicks+=response.ExtLinks[li].clicks;

                  var pn = response.ExtLinks[li].pageNumber;
                  if(!pn || pn == -1){
                    pn = 0;
                  }

                  if(dt[pn]){
                      dt[pn].clicks+=response.ExtLinks[li].clicks; 
                      dt[pn].engagementItems.push(response.ExtLinks[li]);
                  }else{
                      dt[pn] = { pageNumber : response.ExtLinks[li].pageNumber, hits : 0, avg : 0, count : 1, clicks : 0, engagementItems : [] };  
                      dt[pn].clicks = response.ExtLinks[li].clicks;
                      dt[pn].engagementItems.push(response.ExtLinks[li]);
                  }
                }
                this.setState({linkClicks : totalLinkClicks});
              }

              // clear the CDN cache
              _this.setState({analyticsDisabled : false});

              if(action){
                fetch("https://"+WEB_URL+"/account/api/clear-cdn-cache",{
                  'method' : 'POST',
                  'headers' : { 'Content-Type' : 'application/json'},
                  'body' : JSON.stringify({'token':this.props.authDetail.token, 'identifier' : this.props.match.params.publication}),
                }).then(res => res.json())
                  .then(
                    (response) => {
                      _this.setState({analyticsDisabled : false});
                    })
              }

            }else if(response.result == 'MAINTENANCE'){
              _this.setState({runningSearch : false, analyticsDisabled : true});
              this.props.triggerNotification('error','tc',response.message);              
            }else{
              if(action){
                fetch("https://"+WEB_URL+"/account/api/clear-cdn-cache",{
                  'method' : 'POST',
                  'headers' : { 'Content-Type' : 'application/json'},
                  'body' : JSON.stringify({'token':this.props.authDetail.token, 'identifier' : this.props.match.params.publication}),
                }).then(res => res.json())
                  .then(
                    (response) => {
                      
                    })
              }
              
              this.setState({lineData : {labels : [],series : []}, totalPagesRead : 0});
              this.setState({uniqueReads : 0});
              this.setState({avgReadTime : 0});
              this.setState({linkClicks : 0});

              _this.setState({runningSearch : false, analyticsDisabled : true});
              this.props.triggerNotification('error','tc','Analytics are not enabled for this publication. Click on "Enable Analytics" to start collecting data.');
            }

            _this.setState({runningSearch : false});
          },
          (error) => {
            _this.setState({runningSearch : false});
          }
        )
      }catch(e){
        _this.setState({runningSearch : false}); 
      }
  }

  createLegend(json) {
    var legend = [];
    for (var i = 0; i < json["names"].length; i++) {
      var type = "fa fa-circle text-" + json["types"][i];
      legend.push(<i className={type} key={i} />);
      legend.push(" ");
      legend.push(json["names"][i]);
    }
    return legend;
  }

  setDateStart(d){
    this.setState({dateStart : d});
  }

  setDateEnd(d){
    this.setState({dateEnd : d});
  }

  getCloudLink(printMode,printWidth,fetchPage,gradientOverlay){
    if(!gradientOverlay){
        return "https://"+this.props.authDetail.user+".flowpaper.com/"+this.props.match.params.publication+"/"+(printMode?"index.html?"+(new Date().getTime())+"#DisplayRange="+fetchPage+",DisableOverflow=true,PrintWidth="+printWidth:"");
    }else{
        return "https://"+this.props.authDetail.user+".flowpaper.com/"+this.props.match.params.publication+"/"+(printMode?"index.html?"+(new Date().getTime())+"#section="+(fetchPage-1)+",GradientOverlay="+gradientOverlay:"");
    }
  }

  getCloudLinkDetail(publication){
    if(this.props.authDetail.detail.cloudId){
      return "https://"+this.props.authDetail.detail.cloudId+".flowpaper.com/"+publication+"/";
    }else{
      return "https://online.flowpaper.com/"+this.props.authDetail.user+"/"+publication+"/";
    }
  }

  goBack(){
    if(this.props.match.params.identifier && this.props.match.params.identifier.length > 1){
      this.props.history.push('/home/trackablelinks/'+this.props.match.params.publication); 
    }else{
      this.props.history.push('/home/cloud/'); 
    }
  }

  onEnableAnalytics(){
    this.fetchStats('ENABLE');
  }

  onDisableAnalytics(){
    this.fetchStats('DISABLE');
  }

  viewPageDataDetail(pageNumber,index){
    var ed_items = document.querySelectorAll('.engagementDetail');
    for(var ii=0;ii<ed_items.length;ii++){
        ed_items[ii].style['background'] = '';
    }

    if(pageNumber==null || pageNumber == -1){
      pageNumber = 0;
    }

    if(this.state.pageData[pageNumber]){
      this.setState({engagementDetail : this.state.pageData[pageNumber].engagementItems});
    }else{
      this.setState({engagementDetail : null});
    }

    document.getElementById('engagementDetail_'+index).style['background'] = '#ffa';
  }

  triggerEngagement(category,action){
    if(action && action.indexOf('http')==0){
      window.open(action,'_blank');
    }
  }

  getEngagemenType(original){
    switch(original){
      case "onExternalLinkClicked":
        return 'Link';
        break;

      case "onVideoStarted":
          return 'Video';
          break;        

      case "onAudioStarted":
        return 'Audio';
        break;                  

      default:
        return '';
        break;  
    }
  }

  getEngagementAction(type,action){
    switch(type){
      case "onExternalLinkClicked":
        return action;
        break;

      case "onVideoStarted":
        return action.length<20?'Play':action;
          break;        

      case "onAudioStarted":
        return action.length<20?'Play':action;
        break;                  

      default:
        return '';
        break;  
    }
  }

  render() {
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              { (window.location.href.indexOf('?route=dtp')==-1?<ProgressButton waitingText="Please Wait.." bsStyle="default btn-wd btn btn-sm" fill type="submit" onClick={(e) => {this.goBack(e);}}><i class="pe-7s-back"></i> Go Back</ProgressButton>:'')}
              {(this.state.analyticsDisabled?<Button bsStyle="info pull-right" fill type="submit" onClick={(e) => {this.onEnableAnalytics(e);}}>
                    Enable Analytics
              </Button>:'')}
              {(!this.state.analyticsDisabled?<Button bsStyle="warning pull-right" fill type="submit"  onClick={(e) => {this.onDisableAnalytics(e);}}>
                    Disable Analytics
              </Button>:'')}
            </Col>
        </Row>
        { (window.location.href.indexOf('?route=dtp')==-1?
          <Row>
            <Col md={10}>
            <h4 style={{'margin-top':20}}><b>Publication</b>: <a target="_new" href={this.getCloudLink()}>{this.getCloudLinkDetail(this.props.match.params.publication)}</a></h4>
            </Col>
        </Row>
        :'')}
        <Row>
            <Col md={3}>
              <FormGroup>
                <label class="control-label">Date From</label>
                <Datetime
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  inputProps={{ placeholder: "Datetime Picker Here" }}
                  defaultValue={this.state.dateStart}
                  onChange={(d) => this.setDateStart(d)}
                />
               </FormGroup>
             </Col>
             <Col md={3}>
              <FormGroup>
                <label class="control-label">Date To</label>
                <Datetime
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  inputProps={{ placeholder: "Datetime Picker Here" }}
                  defaultValue={this.state.dateEnd}
                  onChange={(d) => this.setDateEnd(d)}
                />
               </FormGroup>
             </Col>      
             <Col md={3}>
              <FormGroup>
                <label style={{visibility:'hidden',display:'block'}} class="control-label">---</label>
                <ProgressButton waitingText="Please Wait.." runningAsyncOperation={this.state.runningSearch} bsStyle="info" fill type="submit" onClick={(e) => {this.fetchStats(null);}}>
                    Set Date Range
                </ProgressButton>
              </FormGroup>
             </Col>       
          </Row>
          <Row>
            <Col lg={3} sm={6}>
              <StatsCard
                bigIcon={<i className="pe-7s-look text-warning" />}
                statsText="Sessions"
                statsValue={this.state.uniqueReads}
                statsIcon={<i className="fa fa-clock-o" />}
                statsIconText="Daily Unique Sessions"
              />
            </Col>
            <Col lg={3} sm={6}>
              <StatsCard
                bigIcon={<i className="pe-7s-bookmarks text-warning" />}
                statsText="Reads"
                statsValue={this.state.totalPagesRead}
                statsIcon={<i className="fa fa-clock-o" />}
                statsIconText="Total # of Pages Read"
              />
            </Col>
            <Col lg={3} sm={6}>
              <StatsCard
                bigIcon={<i className="pe-7s-clock text-warning" />}
                statsText="Time/Page"
                statsValue={this.state.avgReadTime}
                statsIcon={<i className="fa fa-clock-o" />}
                statsIconText="Avg Read Time (secs)"
              />
            </Col>
            <Col lg={3} sm={6}>
              <StatsCard
                bigIcon={<i className="pe-7s-link text-warning" />}
                statsText="Clicks"
                statsValue={this.state.linkClicks}
                statsIcon={<i className="fa fa-clock-o" />}
                statsIconText="External Link Clicks"
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Card
                statsIcon="fa fa-history"
                id="chartHours"
                title="Publication Analytics"
                category="All pages in the publication"
                stats="Updated every hour"
                content={
                  <div className="ct-chart">
                    <ChartistGraph
                      data={this.state.lineData}
                      type="Line"
                      options={this.state.lineOptions}
                      responsiveOptions={responsiveSales}
                    />
                  </div>
                }
                legend={
                  <div className="legend">{this.createLegend(legendAnalytics)}</div>
                }
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
            <Card
                statsIcon="fa fa-history"
                id="pageLevelStats"
                title="Page Level Analytics"
                category=""
                stats="Updated every hour"
                content={
                  <Table striped hover>
                    <thead>
                      <tr>
                        <th>Page</th>
                        <th>Avg. Time (mm:ss)</th>
                        <th>Views</th>
                        <th>Engagements</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.pageData.map((pageStats, index) => {
                          return (
                              <tr onClick={(e) => this.viewPageDataDetail(pageStats.pageNumber,index, e)} class={'engagementDetail'} style={{'cursor':'pointer'}} id={`engagementDetail_${index}`} key={`${index}`}>
                                  <td style={{'width':'40px'}}>{pageStats.pageNumber>0?pageStats.pageNumber:'(unassigned)'}</td>
                                  <td style={{'width':'40px'}}>{pageStats.pageNumber>0?this.formatTime(pageStats.avgTimeSpent):''}</td>
                                  <td style={{'width':'40px'}}>{pageStats.pageNumber>0?pageStats.hits:''}</td>
                                  <td style={{'width':'80px'}}>{pageStats.clicks}  
                                  
                                  {pageStats.clicks>0?<ProgressButton runningAsyncOperation={false} bsStyle="info pull-right btn-xs" style={{marginRight:0,'min-height':'28px','min-width':'78px'}} fill type="submit" onClick={(e) => this.viewPageDataDetail(pageStats.pageNumber,index, e)}>
                                  Show Details
                                  </ProgressButton>:''}
                                  </td>
                              </tr>
                          );
                      })}
                      </tbody>
                </Table>  
                }
                legend={
                  <span></span>
                }
                />
            </Col>
            <Col md={6}>
            {this.state.engagementDetail?<Card
                  statsIcon="fa fa-history"
                  id="pageLevelDetailStats"
                  title="Engagement Details"
                  category=""
                  stats="Updated every hour"
                  content={
                    <Table striped hover>
                      <thead>
                        <tr>
                          <th style={{'font-size':'11px'}}>Date</th>
                          <th style={{'font-size':'11px'}}>Type</th>
                          <th style={{'font-size':'11px'}}>Action</th>
                          <th style={{'font-size':'11px'}}>Label</th>
                          <th style={{'font-size':'11px'}}>Clicks</th>
                        </tr>
                      </thead>
                      <tbody>
                      {this.state.engagementDetail.map((ed, index) => {
                          return (
                        <tr>
                          <td style={{'width':'30px','font-size':'11px'}}>{new Date(ed.date).toLocaleDateString()}</td>
                          <td style={{'width':'30px','font-size':'11px'}}>{this.getEngagemenType(ed.category)}</td>
                          <td style={{'width':'50%','font-size':'11px'}}>{this.getEngagementAction(ed.category,ed.action)}</td>
                          <td style={{'width':'40px','font-size':'11px'}}>{ed.label}</td>
                          <td style={{'width':'30px','font-size':'11px'}}>{ed.clicks}</td>
                        </tr>
                        );
                      })}
                      </tbody>
                  </Table>  
                  }
                  legend={
                    <span></span>
                  }
                  />:''}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Analytics;
